import { Component } from '@angular/core';

@Component({
  selector: 'app-spinner-overlay',
  templateUrl: './spinner-overlay.component.html',
})
export class SpinnerOverlayComponent {}
